import PropTypes from "prop-types";

import { WrapperContainer, FlexContainers } from "../../components";
import TabButton from "./TabButton";

const TabsSelector = ({ tabs, activeTab, onSelectTab }) => {
  return (
    <WrapperContainer Container={FlexContainers.FlexRowStart} gap={8}>
      {tabs &&
        tabs.map((tab) => {
          return (
            <TabButton
              key={tab.id}
              title={tab.title}
              active={activeTab === tab.id}
              onClick={() => onSelectTab(tab.id)}
            />
          );
        })}
    </WrapperContainer>
  );
};

TabsSelector.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  activeTab: PropTypes.bool.isRequired,
  onSelectTab: PropTypes.func.isRequired
};

export default TabsSelector;
